import { db } from "../firebase/config";
import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  getDocs
} from "firebase/firestore";

export const DEFAULT_TEAMING_SECTIONS = [
  {
    id: "sec_1",
    sectionNumber: "1",
    title: "Definitions",
    content: `The terms set forth herein are defined as follows:
a. “{{procurementTitle}}” Procurement” or “the Procurement” means the entire process pursuant to which the Customer selects and processes, whether by purchase, lease, license or any other means, the acquisition of the goods and/or services described in the Solicitations, including but not limited to any and all pre-proposal activity, the submission of proposals, the conduct of benchmarks (if any), negotiations, clarifications and/or discussions (if any) with respect to any contracts resulting therefrom, and the award of any such contracts;
b. “Proprietary Information” shall have the same meaning as set forth in any separate Non-Disclosure Agreement between the parties; and
c. “Solicitation” means Solicitation or RFP/RFL, all modifications, or amendments thereto.`
  },
  {
    id: "sec_2",
    sectionNumber: "2",
    title: "Parties’ Responsibilities",
    content: `Each Party will work with the other in good faith with the objective of developing a proposal or proposals which will cause the selection of the Team for the Procurement and each Party shall continue to exert reasonable, good faith efforts toward this objective throughout all negotiations concerning a proposed contract or subcontracts which may follow the submission of such proposal or proposals. This requirement includes the furnishing by each Party of sufficient qualified personnel to assist in preparing proposals and related materials.`
  },
  {
    id: "sec_3",
    sectionNumber: "3",
    title: "Identification of Parties",
    content: `It is understood that in proposals submitted for the Procurement, each Party will be identified as a Team member, to the extent deemed necessary and appropriate, and the relationship and respective areas of responsibility of the Parties will be described.`
  },
  {
    id: "sec_4",
    sectionNumber: "4",
    title: "Additional Team Members",
    content: `Notwithstanding any other provision herein to the contrary, both parties reserve the right to add additional team members to the Procurement team to assist in performing tasks and areas of work and responsibility thereunder and take whatever actions it deems reasonably necessary to produce a proposal or proposals that have the greatest likelihood of resulting in the selection of the Team for the Procurement. If additional team members are added, both parties agree to obtain adequate written protection of Proprietary Information from any other team member(s).`
  },
  {
    id: "sec_5",
    sectionNumber: "5",
    title: "Responsibilities",
    content: `{{leadProposalParty}} shall take the lead in writing proposal’s to be submitted for each solicitation. Each Team Member will furnish, for incorporation into any proposal, all proposal materials, information, and data pertinent to the work assigned to the Party, including but not limited to, manuscripts, artwork, and cost and/or pricing data, as appropriate. The cost format and work breakdown structure in the proposal shall be as specified in the solicitation.`
  },
  {
    id: "sec_6",
    sectionNumber: "6",
    title: "Personnel",
    content: `At {{leadProposalParty}}’s request, LAT shall make available appropriate management and technical personnel to assist {{leadProposalParty}} in any discussions, communications or negotiations with the Customer relating to the Procurement.`
  },
  {
    id: "sec_7",
    sectionNumber: "7",
    title: "Costs/Limitation of Liability",
    content: `Each Party shall bear all costs, expenses, risks, and liabilities incurred by it arising out of or relating to its obligations, efforts, or performance under this Agreement. Neither Party shall have any right to any reimbursement, payment, or compensation of any kind from the other during the term of this Agreement accept as outlined in the attached Exhibits. The liability of either Party to the other for any claims, liabilities, actions, or damages arising out of or relating to this Agreement, howsoever caused and regardless of the legal theory asserted, including breach of contract or warranty, tort, strict liability, statutory liability or otherwise, shall not, in the aggregate, exceed the amount of out-of-pocket costs incurred by the other Party under this Agreement.

In no event shall either Party be liable to the other for any punitive, exemplary, special, indirect, incidental or consequential damages (including, but not limited to, lost profits, lost revenues, lost business opportunities, loss of use or equipment down time, and loss of or corruption to data) arising out of or relating to this Agreement, regardless of the legal theory under which such damages are sought, and even if the Parties have been advised of the possibility of such damages or loss.`
  },
  {
    id: "sec_8",
    sectionNumber: "8",
    title: "Submissions to the Customer",
    content: `{{leadProposalParty}} shall have the right to decide the form and content of documents submitted to the Customer. {{leadProposalParty}} will make reasonable efforts to ensure that the LAT’s data is accurately and adequately portrayed and identified as LAT’s portion. {{leadProposalParty}} will afford LAT the opportunity to review, upon request prior to proposal submission, that portion of the proposal that includes the effort to be performed by LAT.`
  },
  {
    id: "sec_9",
    sectionNumber: "9",
    title: "Contacts",
    content: `LAT shall be the main contact with the Customer concerning the Procurement. However, {{leadProposalParty}} may contact the Customer concerning the Procurement, with the prior approval of LAT, which shall not be unreasonably withheld.`
  },
  {
    id: "sec_10",
    sectionNumber: "10",
    title: "Communications with the Customer",
    content: `Although LAT is considered as the main interface with the Customer, it is recognized that {{leadProposalParty}} may have continuing relations with the Customer and may be the recipient of inquiries concerning the Procurement. Therefore, any communications initiated by the Customer directly with either Party concerning this Procurement are permissible, provided the other Party is notified promptly of such communications and the substance thereof, but in no event later than one business day after such communication.`
  },
  {
    id: "sec_11",
    sectionNumber: "11",
    title: "Presentations",
    content: `In the event either Party is afforded the opportunity to make presentations, whether orally or in writing, to the Customer concerning the Procurement, the content of such presentations shall be made known to the other Party, subject to any prohibitions or restrictions that may be imposed by the Customer upon such disclosure. Each Party agrees to support such presentations, as may be requested by the other Party, to the extent such presentations relate to the other Party’s area of work.`
  },
  {
    id: "sec_12",
    sectionNumber: "12",
    title: "Public Announcements/Disclosures",
    content: `Any news release, public announcement, advertisement, or other form of publicity released or disclosed by either Party concerning this Agreement or any proposals relating thereto, shall be subject to the prior approval of each Party, which shall not be unreasonably withheld. Any such public announcement, release or disclosure shall give due credit to the contribution of each Party.`
  },
  {
    id: "sec_13",
    sectionNumber: "13",
    title: "Points of Contact",
    content: `The Parties each will designate one or more individuals within their respective organizations as their representative(s) responsible for directing performance of the Parties’ obligations under this Agreement.`
  },
  {
    id: "sec_14",
    sectionNumber: "14",
    title: "Proprietary/Confidential Information",
    content: `In carrying out the terms of this Agreement, it may be necessary for the Parties to provide proprietary and/or confidential information to one another. In such an event, the disclosure and use of all proprietary and/or confidential information shall be in accordance with any separate Non-Disclosure Agreement between the Parties.`
  },
  {
    id: "sec_15",
    sectionNumber: "15",
    title: "Inventions/Patents",
    content: `Nothing contained in this Agreement shall, by express grant, implication, estoppel or otherwise, create in either Party any right, title, interest, or license in or to the inventions, patents, computer software or software documentation of the other Party.`
  },
  {
    id: "sec_16",
    sectionNumber: "16",
    title: "Termination/Expiration",
    content: `This Agreement shall remain in effect until the first of the following shall occur:
a. A decision by either Party that it no longer wishes to participate in the teaming agreement, provided that such decision is communicated in writing to the other Party.
b. Inability of either Party, after negotiating in good faith for a reasonable period, to reach agreement on the terms and conditions of a contract. If such agreement has not been reached within 60 days from the initiation of negotiations, it will be deemed that the Parties were unable to reach agreement.
c. One year after the effective date of this Agreement, unless extended in writing by the Parties. However, the termination or expiration of this Agreement shall not supersede or affect the obligations of the Parties with respect to the completion of all Customer Procurements/Leases as set forth in the attached Exhibits and which shall survive such termination or expiration of this Agreement and remain in full force and effect until all {{customerAcronym}} lease periods have ended.
d. The laws relating to bankruptcy, the relief of debtors or assignment for the benefit of creditors or admits in writing its inability to pay its debts as they become due.`
  },
  {
    id: "sec_17",
    sectionNumber: "17",
    title: "Survival",
    content: `The termination or expiration of this Agreement shall not supersede or affect the obligations of the Parties with respect to the protection of Proprietary Information, as set forth in any separate Non-Disclosure Agreement between the Parties, which shall survive such termination or expiration and remain in full force and effect.`
  },
  {
    id: "sec_18",
    sectionNumber: "18",
    title: "Notices",
    content: `All notices, certificates, acknowledgments or other written communications (hereinafter referred to as “Notices”) required to be given under this Agreement shall be in writing and shall be deemed to have been given and properly delivered if duly mailed by certified or registered mail to the other Party at its address as follows, or to such other address as either Party may, by written notice, designate to the other. Additionally, Notices sent by any other means (i.e., facsimile, overnight delivery, courier, and the like) are acceptable subject to written confirmation of both the transmission and receipt of the Notice.

{{noticesLat}}

{{noticesPartner}}`
  },
  {
    id: "sec_19",
    sectionNumber: "19",
    title: "Relationship of Parties",
    content: `This Agreement is not intended by the Parties to constitute or create a joint venture, limited liability company, pooling arrangement, partnership, or other formal business organization of any kind, other than a contractor team arrangement, and the rights and obligations of the Parties shall be only those expressly set forth herein. Neither Party shall have authority to bind the other except to the extent expressly authorized herein. Nothing in this Agreement shall be construed as providing for the sharing of profits or losses arising out of the efforts of either or both Parties. It is also understood that no division of markets is attempted by this Agreement.`
  },
  {
    id: "sec_20",
    sectionNumber: "20",
    title: "Assignment",
    content: `This Agreement may not be assigned, novated, or otherwise transferred by operation of law or otherwise by either Party without the prior written consent of the other Party, which consent shall not be unreasonably withheld. Any change of control of a Party shall be deemed an assignment of this Agreement that requires the prior written consent of the other Party. For purposes of this Agreement, “change of control” means any merger, consolidation, sale of all or substantially all the assets or sale of a substantial block of stock, of a Party. Any such assignment, novation, or transfer by one Party not in accordance with this provision shall be a material breach of this Agreement and shall be grounds for immediate termination thereof by the non-breaching Party, in addition to any other remedies that may be available at law or in equity to the non-breaching Party.`
  },
  {
    id: "sec_21",
    sectionNumber: "21",
    title: "Modifications/Non-Waiver of Rights",
    content: `This Agreement shall not be amended, modified, or extended, nor shall any waiver of any right hereunder be effective, unless set forth in a document executed by duly authorized representatives of both Parties, specifically referencing the provision of this Agreement to be amended, modified, extended, or waived. The failure of either Party to insist upon performance of any provision of this, or to exercise any right, remedy or option provided herein, shall not be construed or deemed as a waiver of the right to assert any of the same at any time thereafter.`
  },
  {
    id: "sec_22",
    sectionNumber: "22",
    title: "Customer’s Right to Negotiate",
    content: `Nothing herein is intended to affect the rights of the Customer to negotiate directly with either Party hereto on any basis the Customer may desire.`
  },
  {
    id: "sec_23",
    sectionNumber: "23",
    title: "Entire Agreement",
    content: `This Agreement, including all Exhibits hereto which are incorporated herein by reference, constitutes the entire agreement and understanding between the Parties hereto, and supersedes and replaces all previous or contemporaneous understandings, commitments, agreements, proposals, or representations of any kind, whether oral or written, relating to the subject matter hereof.`
  },
  {
    id: "sec_24",
    sectionNumber: "24",
    title: "Severability",
    content: `If any term, condition or provision of this Agreement is held or finally determined to be void, invalid, illegal, or unenforceable in any respect, in whole or in part, such term, condition or provision shall be severed from this Agreement, and the remaining terms, conditions and provisions contained herein shall continue in force and effect, and shall in no way be affected, prejudiced or disturbed thereby.`
  },
  {
    id: "sec_25",
    sectionNumber: "25",
    title: "Governing Law",
    content: `This Agreement shall be governed by and construed, enforced, and interpreted under the laws of the Commonwealth of Pennsylvania, without regard to its laws relating to conflict or choice of laws. Any dispute, claim, action, or suit arising out of or relating to this Agreement may only be brought exclusively in a court of competent jurisdiction in the Commonwealth of Pennsylvania.`
  },
  {
    id: "sec_26",
    sectionNumber: "26",
    title: "Compliance with Law",
    content: `The Parties to this Agreement shall comply with all applicable laws, rules, regulations, and public policies (“Laws”) that prohibit unethical conduct regarding the obtaining, retention or conduct of business or an unfair advantage. The Parties shall not directly or indirectly give, offer, promise, authorize, or allow to be given, offered, or promised, anything of value to an official or employee of any government, state-owned enterprise, international organization including subdivisions thereof or entities acting on behalf of a government, state-owned enterprise, international organization or subdivision thereof (any such employee or official referred to collectively as “Official”), while knowing or having reason to know that such thing of value is to be given, offered, or promised to an Official (including political parties or officials thereof or candidates for foreign office) in order to: (i) influence any official act or decision of such Official, or (ii) induce such Official to use his influence to affect or influence any act or decision of any government (or any subdivision thereof), or (iii) assist the Parties in obtaining or retaining business, or in directing business to any person or obtain an unfair advantage for the Parties in any respect. Should either Party violate any of the Laws then: (i) the other Party shall have the right to immediately terminate the Agreement for cause; (ii) the other Party shall have a right of action against the offending Party for the recovery of any monetary payment(s) or thing(s) of value made or given by the offending Party in breach of such Laws; and (iii) the offending Party shall indemnify the other Party for any penalty, loss or expenses incurred by the other Party as a result of the offending Party's breach of any of its obligations under this Article.`
  },
  {
    id: "sec_27",
    sectionNumber: "27",
    title: "Headings",
    content: `The headings and titles of the various sections of this Agreement are intended solely for convenience of reference and are not intended to define, limit, explain, expand, modify, or place any construction on any of the provisions of this Agreement.`
  }
];

export const DEFAULT_TEAMING_TEMPLATE = {
  title: "Teaming Agreement",
  description: "Standard 27-section commercial teaming agreement template for Government & Commercial Solicitations.",
  isDefault: true,
  preambleTemplate: `THIS TEAMING AGREEMENT, including all Exhibits attached hereto or referenced herein (hereinafter referred to as “this Agreement”), is made and entered into this {{day}} day of {{month}}, {{year}}, by and between Longarm Technologies, LLC (“LAT”), a Nevada corporation with offices located at 1543 Frew mill Rd News Castle PA, and {{partnerName}} a {{partnerState}} corporation with offices located at {{partnerAddress}}. These two entities are sometimes referred to collectively herein as the “Team or Parties” and individually as a “Party.”`,
  recitals: [
    `WHEREAS, the {{customerName}}, herein referred to as “Customer” or {{customerAcronym}} is planning to issue solicitations (“Solicitations”) for the acquisition of {{procurementDescription}} (“Procurement”).`,
    `WHEREAS, each of the Parties has determined that it would benefit from a team arrangement in order to develop the optimal approach to responding to each Solicitation, and because of each Party’s unique capabilities, the Parties recognize the efficiency of teaming together and therefore wish to team together for the purpose of competitively responding to each Solicitation and obtaining contract(s) and/or purchase/task order(s) resulting therefrom (herein referred to as “Orders”);`,
    `WHEREAS, the Parties wish to enter into this Agreement to set forth more fully the terms and conditions pursuant to which the Parties will, as a Team, respond to the Solicitations and obtain any Order(s) resulting therefrom, and the Parties have agreed to the respective responsibilities of work to be performed by each Party on the Procurement, as set forth in the Solicitation; and`,
    `WHEREAS, the ability of the Parties to competitively respond to the Solicitations and to obtain contracts resulting therefrom will necessitate the disclosure by each Party to the other of its Proprietary Information, and the Parties are willing to make their Proprietary Information available to the other Party for the limited purpose of competitively responding to the Solicitations and obtaining order(s) resulting therefrom, and each of the Parties is willing to accept the Proprietary Information from the other Party in confidence for use solely and exclusively in connection with competitively responding to the Solicitations and obtaining orders(s) resulting therefrom, in accordance with the terms and conditions of this Agreement and any Non-Disclosure Agreement the Parties have entered into.`
  ],
  sections: DEFAULT_TEAMING_SECTIONS,
  defaultLatNotices: `Longarm Technologies, LLC
3057 William Flynn Hwy
Slippery Rock, PA 16057
Attention: Dale Flippo/James Pasqualini
Phone: (866) 668-6060
email: support@longarmtechnologies.com`,
  defaultPartnerNotices: `{{partnerCompany}}
{{partnerAddress}}
Attention: {{partnerPocName}}
Phone: {{partnerPocPhone}}
email: {{partnerPocEmail}}`,
  signatoryLat: {
    company: "Longarm Technologies, LLC",
    signatoryName: "Dale Flippo / James Pasqualini",
    signatoryTitle: "President / Vice President"
  }
};

/**
 * Seeds the default Master Teaming Agreement Template if none exists in Firestore.
 */
export async function seedDefaultAgreementTemplates() {
  try {
    const snapshot = await getDocs(collection(db, "agreement_templates"));
    if (snapshot.empty) {
      await addDoc(collection(db, "agreement_templates"), {
        ...DEFAULT_TEAMING_TEMPLATE,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      });
      console.log("Seeded default Teaming Agreement template.");
    }
  } catch (err) {
    console.error("Error seeding default agreement template:", err);
  }
}

/**
 * Subscribe to Master Agreement Templates (in Settings)
 */
export function subscribeToAgreementTemplates(callback) {
  return onSnapshot(
    collection(db, "agreement_templates"),
    (snapshot) => {
      const list = [];
      snapshot.forEach((d) => {
        list.push({ id: d.id, ...d.data() });
      });
      list.sort((a, b) => {
        if (a.isDefault && !b.isDefault) return -1;
        if (!a.isDefault && b.isDefault) return 1;
        return (a.title || "").localeCompare(b.title || "");
      });
      callback(list);
    },
    (error) => {
      console.error("Error subscribing to agreement templates:", error);
      callback([], error);
    }
  );
}

export async function addAgreementTemplate(data) {
  const docRef = await addDoc(collection(db, "agreement_templates"), {
    ...data,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  });
  return docRef.id;
}

export async function updateAgreementTemplate(id, data) {
  const docRef = doc(db, "agreement_templates", id);
  await updateDoc(docRef, {
    ...data,
    updatedAt: new Date().toISOString()
  });
}

export async function deleteAgreementTemplate(id) {
  const docRef = doc(db, "agreement_templates", id);
  await deleteDoc(docRef);
}

/**
 * Subscribe to Partner Agreements (in Partners -> Agreements tab)
 */
export function subscribeToPartnerAgreements(callback) {
  return onSnapshot(
    collection(db, "partner_agreements"),
    (snapshot) => {
      const list = [];
      snapshot.forEach((d) => {
        list.push({ id: d.id, ...d.data() });
      });
      list.sort((a, b) => new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0));
      callback(list);
    },
    (error) => {
      console.error("Error subscribing to partner agreements:", error);
      callback([], error);
    }
  );
}

export async function addPartnerAgreement(data) {
  const docRef = await addDoc(collection(db, "partner_agreements"), {
    ...data,
    status: data.status || "Draft",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  });
  return docRef.id;
}

export async function updatePartnerAgreement(id, data) {
  const docRef = doc(db, "partner_agreements", id);
  await updateDoc(docRef, {
    ...data,
    updatedAt: new Date().toISOString()
  });
}

export async function deletePartnerAgreement(id) {
  const docRef = doc(db, "partner_agreements", id);
  await deleteDoc(docRef);
}
